import React, { useState, useEffect } from 'react';
import CountUp from 'react-countup';
import { useSelector } from 'react-redux';
import { ethers } from 'ethers';

const BuyTicketSection = ({ setShowModal }) => {
  const [lastScrollY, setLastScrollY] = useState(0);
  const [balance, setBalance] = useState(0);

  const { connect, lotteryContract, tuesdayContract } = useSelector(
    state => state.provider
  );

  const { both, tuesday, friday, tuesdayTime, fridayTime } = useSelector(state => state.lotteryDay);
  const onScroll = () => {
    setLastScrollY(window.scrollY);
  };

  useEffect(
    () => {
      if (connect) {
        getBalance();
      }
    },
    [connect]
  );

  const getBalance = async () => {
    let bal = 0;
    // console.log("getBalance");
    if (both) {
      if (parseInt(tuesdayTime) < parseInt(fridayTime)) {
        bal = await tuesdayContract.functions.getBalance();
      } else {
        bal = await lotteryContract.functions.getBalance();
      }
    } else {
      if (tuesday) {
        // console.log('tuesday');
        bal = await tuesdayContract.functions.getBalance();
      } else {
        // console.log('friday');
        bal = await lotteryContract.functions.getBalance();
      }
    }

    setBalance(parseFloat(ethers.utils.formatEther(bal.toString())).toFixed(3));
  };


  return (
    <div className="my-10">
      <h2 className="mb-10 text-3xl sm:text-4xl sm:my-5 text-lyellow px-[2.3em] font-semibold text-center">
        Grab A Bag <span className="text-white">Lottery</span>
      </h2>
      {both
        ? <>
          {(parseInt(tuesdayTime) < parseInt(fridayTime)) ?
            <h1 className="text-lyellow font-sans font-bold text-center mt-6 text-2xl">
              Tuesday Lottery{' '}
            </h1>
            :
            <h1 className="text-lyellow font-sans font-bold text-center mt-6 text-2xl">
              Friday Lottery
            </h1>
          }
        </>
        : tuesday
          ? <h1 className="text-lyellow font-sans font-bold text-center mt-6 text-2xl">
            Tuesday Lottery{' '}
          </h1>
          : <h1 className="text-lyellow font-sans font-bold text-center mt-6 text-2xl">
            Friday Lottery
          </h1>
      }

      <div className="px-[5em] mt-5 flex items-center justify-center w-screen">
        <div className="flex justify-center items-center px-10 py-16 sm:px-40 bg-black/40 border border-black/80 rounded-xl shadow-xl">
          <div className="flex flex-col items-center w-full">
            <h1 className="font-bold text-lyellow text-5xl">
              $ {balance}
            </h1>

            <p className="mb-8 text-center my-4 text-2xl md:text-3xl text-lyellow">
              In Prizes
            </p>

            <div className="flex justify-center items-center">
              <div className="flex items-center justify-center relative  ">
                <div className="bg-lyellow text-md font-semibold py-[3.5em] px-[2.6em] border-dotted border-r-[0.4em] border-black rounded-t-2xl rounded-b-2xl  transition ease-in duration-200 " />
                <div className="bg-lyellow text-md font-semibold py-[3.5em] px-[5.6em] rounded-2xl border-dotted border-l-[0.4em] border-black  transition ease-in duration-200 " />

                <button
                  className="absolute bg-[#1d2226]  text-md font-semibold py-4 px-[3.6em] hover:opacity-90 text-white hover:text-white rounded-xl"
                  onClick={() => setShowModal(true)}
                >
                  Buy Ticket
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyTicketSection;
